"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableFieldEmail = void 0;
var TableTextField_1 = __importDefault(require("atomicComponents/molecules/Forms/TableTextField"));
var FieldText_1 = __importDefault(require("components/Form/FieldText"));
var DefaultPropsHoC_1 = __importDefault(require("components/Generic/DefaultPropsHoC"));
var validators_1 = require("utils/form/validators");
var TableFieldText = (0, DefaultPropsHoC_1.default)(FieldText_1.default, { component: TableTextField_1.default });
exports.TableFieldEmail = (0, DefaultPropsHoC_1.default)(FieldText_1.default, {
    component: TableTextField_1.default,
    type: 'email',
    validate: validators_1.getEmailError,
    placeholder: 'Email Address',
});
exports.default = TableFieldText;
